import React, { useState, useEffect } from "react";
import darkNewImg from "~/common/components/Images";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import useAlert from "~/common/hooks/useAlert";

const EvaluateSection = ({
	viewtype,
	showConfirmAlert,
	userNm,
	evalDetailData,
	setApplyResultModal,
}) => {
	const [itemScore, setItemScore] = useState({});
	const [finalData, setFinalData] = useState([]);
	const [calculatedScore, setCalculatedScore] = useState({});
	const [scoreSend, setScoreSend] = useState({});
	const [totalScore, setTotalScore] = useState(0);
	const [comment, setCommnet] = useState("");

	const evalSubmitRequest = useRequest("post", "vc/round/external/review", "gitbal", true);

	const [showErrorAlert, ErrorAlert] = useAlert();

	useEffect(() => {
		const score =
			Object.values(calculatedScore).length === 0 ? [0] : Object.values(calculatedScore);
		const total = score.reduce((acc, cur) => {
			acc = acc + cur;
			return acc;
		});
		setTotalScore(total);
	}, [calculatedScore]);

	useEffect(() => {
		let CalScore = [];
		let tmpScore = [];
		setCommnet(evalDetailData?.reviewResult?.comment);
		evalDetailData?.reviewResult?.Score?.map((d) => {
			if (d.score) {
				const scoreKey = d.categoryIdx
					? d.categoryIdx.toString() + "-" + d.itemIdx.toString()
					: 0;
				const targetCate = evalDetailData?.review?.Category?.find(
					(c) => c.idx === d.categoryIdx
				);

				const targetWeight = parseInt(targetCate.weight);
				const itemNum = targetCate?.Item.length;
				const calScore = (d.score / (10 * itemNum)) * targetWeight;

				CalScore = {
					...CalScore,
					[scoreKey]: calScore,
				};
				tmpScore = {
					...tmpScore,
					[scoreKey]: d.score,
				};
			}
		});

		setCalculatedScore({
			...calculatedScore,
			...CalScore,
		});
		setItemScore({
			...itemScore,
			...tmpScore,
		});
	}, [evalDetailData?.reviewResult]);

	const handleScore = (e, catIdx, itemIdx, scoreIdx) => {
		const score = parseInt(e.target.value.replace(/\D/, ""));

		const scoreKey = catIdx.toString() + "-" + itemIdx.toString();
		const targetCate = evalDetailData?.review?.Category?.find((d) => d.idx === catIdx);
		const targetWeight = parseInt(targetCate.weight);

		//최종 데이터 갖고있기
		const changeScore = {
			idx: scoreIdx ? scoreIdx : null,
			categoryIdx: catIdx,
			itemIdx: itemIdx,
			score: isNaN(score) ? 0 : score,
		};

		//중복된 값 빼주기
		const tmpData = finalData.filter(
			(list) =>
				list.categoryIdx.toString() + "-" + list.itemIdx.toString() !==
				changeScore.categoryIdx.toString() + "-" + changeScore.itemIdx.toString()
		);
		const insertData = [...tmpData, changeScore];
		setFinalData(insertData);

		const itemNum = targetCate?.Item.length;
		const calScore = (score / (10 * itemNum)) * targetWeight;

		if (score > 10 || isNaN(score) || score === "") {
			setItemScore({
				...itemScore,
				[scoreKey]: 0,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: 0,
			});
		} else {
			setItemScore({
				...itemScore,
				[scoreKey]: score,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: calScore,
			});
			setScoreSend({
				...scoreSend,
				[scoreKey]: { categoryIdx: catIdx, itemIdx: itemIdx },
			});
		}
	};

	const submitEvaluation = () => {
		const dataForm = {
			roundIdx: evalDetailData?.info?.roundIdx,
			stIdx: evalDetailData?.company?.idx,
			comment: comment,
			totalScore: totalScore,
			scoreList: finalData,
		};
		if (!comment) showErrorAlert();
		else evalSubmitRequest.call(dataForm);
	};

	useEffect(() => {
		switch (evalSubmitRequest.state) {
			case API_STATE.done:
				showConfirmAlert(true);
				setApplyResultModal(false);
				break;
			case API_STATE.error:
				console.log("irEvaluateForm Error");
				break;
			default:
				break;
		}
	}, [evalSubmitRequest.state, evalSubmitRequest.response, evalSubmitRequest.error]);

	return (
		<div className="applicant-evaluate-body">
			<div className="scroll-wrap">
				<div className="judge-form-top">
					<div className="judging-vc-wrap">
						<div className="img-wrap">
							<img src={darkNewImg} alt="심사역 이미지" />
							{/*<img src={lightProfileImg} alt="심사역 이미지" />*/}
						</div>
						<dl className="judging-vc">
							<dt>{userNm}</dt>
							<dd>외부심사원</dd>
						</dl>
					</div>
					<div className="judging-vc-score">
						<b>{totalScore?.toFixed(2)}</b>점
					</div>
				</div>
				{evalDetailData?.review?.Category?.map((category) => (
					<div className="judge-detail-item">
						<div className="category-title">
							{category.title}
							<span>(배점비율 : {category.weight}%)</span>
						</div>
						<form className="c__form">
							{category?.Item?.map((item, itemIdx) => {
								return (
									<div className="f__group" key={item.idx}>
										<div className="f__label">
											{itemIdx + 1}. {item.content}
										</div>
										<div className="f__control">
											<input
												className="c__input"
												onChange={(e) =>
													handleScore(
														e,
														category.idx,
														item.idx,
														item.score ? item.score.idx : null
													)
												}
												value={
													itemScore[
														category.idx.toString() +
															"-" +
															item.idx.toString()
													] || 0
												}
												disabled={!viewtype}
											/>
										</div>
									</div>
								);
							})}
						</form>
					</div>
				))}
				<div className="judge-commentary">
					<div className="category-title">종합평가</div>
					<div className="f__group">
						<div className="f__control">
							<textarea
								value={comment}
								className="c__textarea"
								onChange={(e) => {
									setCommnet(e.target.value);
								}}
								disabled={!viewtype}
								maxLength={2000}
							/>
							<span className="character-length">{comment?.length}/2000</span>
						</div>
					</div>
				</div>
			</div>
			{viewtype ? (
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => submitEvaluation()}
					>
						심사완료
					</button>
				</div>
			) : (
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => submitEvaluation()}
						disabled={true}
					>
						심사기간이 아닙니다.
					</button>
				</div>
			)}
			<ErrorAlert message="종합평가를 입력 해 주세요." type="info" confirm="확인" />
		</div>
	);
};

export default EvaluateSection;
